
module.exports = {
	LATEST_SCORE_FETCH_REQUEST: "LATEST_SCORE_FETCH_REQUEST",
	LATEST_SCORE_FETCH_SUCCESS: "LATEST_SCORE_FETCH_SUCCESS",
	LATEST_SCORE_FETCH_FAILURE: "LATEST_SCORE_FETCH_FAILURE"
};



// WEBPACK FOOTER //
// ./src/common/modules/latestScore/constants.js